import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Details } from '../../../shared/vulns/Drawer';

/**
 * VulnerabilityIssueDetailsDetailsSection displays the description of the vulnerability
 * currently being viewed.
 */
const VulnerabilityIssueDetailsDetailsSection: VoidFunctionComponent = () => {
  const vulnDetails = useSelector(IssuesV2Store.selectors.getVulnDetails);

  if (!vulnDetails) {
    return null;
  }
  return (
    <Details selectedVulnDetails={vulnDetails} />
  );
};

export default VulnerabilityIssueDetailsDetailsSection;
